import { Badge } from '@/components/ui/badge';
import type { ValidityStatus } from '../types/dossier-company.types';

const LABELS: Record<ValidityStatus, string> = {
  valide: 'Valide',
  expire_bientot: 'Expire bientôt',
  expiree: 'Expirée',
  indetermine: 'Indéterminé',
};

const VARIANTS: Record<ValidityStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  valide: 'default',
  expire_bientot: 'secondary',
  expiree: 'destructive',
  indetermine: 'outline',
};

const CLASSNAMES: Record<ValidityStatus, string> = {
  valide: 'bg-green-100 text-green-800 hover:bg-green-100',
  expire_bientot: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  expiree: 'bg-red-100 text-red-800 hover:bg-red-100',
  indetermine: '',
};

export function PieceStatusBadge({ status }: { status: ValidityStatus }) {
  return (
    <Badge variant={VARIANTS[status]} className={CLASSNAMES[status]}>
      {LABELS[status]}
    </Badge>
  );
}
